import { useState } from "react";
import { CUP_COLORS } from "@/data/merchCups";

/** Cup photo with color fallback when image is missing. */
export default function CupImage({ colorId, className = "", alt }) {
    const color = CUP_COLORS.find((c) => c.id === colorId) || CUP_COLORS[0];
    const [failed, setFailed] = useState(false);

    if (!failed && color?.image) {
        return (
            <img
                src={color.image}
                alt={alt || `${color.name} party cup`}
                className={`object-cover ${className}`}
                onError={() => setFailed(true)}
            />
        );
    }

    return (
        <div
            className={`flex items-end justify-center ${className}`}
            style={{ background: `linear-gradient(180deg, ${color.hex}22 0%, ${color.hex} 55%)` }}
            role="img"
            aria-label={alt || `${color.name} cup`}
        >
            <div
                className="w-[55%] h-[78%] rounded-t-2xl rounded-b-md border-2 border-black/10 shadow-inner"
                style={{ backgroundColor: color.hex }}
            />
        </div>
    );
}
